/**
 * pages translations
 * Auto-split from staticTranslations.ts
 */

// ─── Contact Page ─────────────────────────────────────────
export const contact = {
  en: {
    heroSubtitle: "We'd love to hear from you",
    heroTitle: "Contact Us",
    sendMessage: "Send us a message",
    fullName: "Full Name *",
    email: "Email *",
    phone: "Phone",
    messagePlaceholder: "Message *",
    sending: "Sending...",
    send: "Send Message",
    privacyNote: "*Don't worry, these details are saved only for contact purposes according to our",
    privacyPolicy: "Privacy Policy",
    and: "and",
    termsOfUse: "Terms of Use",
    address: "Address",
    addressValue: "58 Herzl St., Beer Sheva",
    phoneLabel: "Phone",
    emailLabel: "Email",
    businessHours: "Business Hours",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    fridayHolidays: "Friday & Holiday Eves",
    saturdayHolidays: "Saturdays & Holidays",
    closed: "Closed",
    mapTitle: "Alice Jewelry Location",
    nameRequired: "Name is required",
    nameMax: "Name must be up to 100 characters",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email address",
    emailMax: "Email must be up to 255 characters",
    phoneMax: "Phone must be up to 20 characters",
    phoneInvalid: "Invalid phone number",
    messageRequired: "Message is required",
    messageMax: "Message must be up to 2000 characters",
    fixFields: "Please fix the highlighted fields",
    securityFailed: "Security verification failed, please refresh and try again",
    messageSent: "Your message was sent successfully!",
    sendError: "An error occurred while sending. Please try again.",
  },
  ru: {
    heroSubtitle: "Мы будем рады услышать вас",
    heroTitle: "Свяжитесь с нами",
    sendMessage: "Отправьте нам сообщение",
    fullName: "Полное имя *",
    email: "Эл. почта *",
    phone: "Телефон",
    messagePlaceholder: "Сообщение *",
    sending: "Отправка...",
    send: "Отправить",
    privacyNote: "*Не волнуйтесь, данные сохраняются только для связи в соответствии с",
    privacyPolicy: "Политика конфиденциальности",
    and: "и",
    termsOfUse: "Условия использования",
    address: "Адрес",
    addressValue: "ул. Герцля 58, Беэр-Шева",
    phoneLabel: "Телефон",
    emailLabel: "Эл. почта",
    businessHours: "Часы работы",
    sunday: "Воскресенье",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    fridayHolidays: "Пятница и кануны праздников",
    saturdayHolidays: "Суббота и праздники",
    closed: "Закрыто",
    mapTitle: "Расположение Alice Jewelry",
    nameRequired: "Имя обязательно",
    nameMax: "Имя должно быть до 100 символов",
    emailRequired: "Эл. почта обязательна",
    emailInvalid: "Неверный адрес эл. почты",
    emailMax: "Эл. почта до 255 символов",
    phoneMax: "Телефон до 20 символов",
    phoneInvalid: "Неверный номер телефона",
    messageRequired: "Сообщение обязательно",
    messageMax: "Сообщение до 2000 символов",
    fixFields: "Исправьте выделенные поля",
    securityFailed: "Проверка безопасности не удалась, обновите страницу",
    messageSent: "Ваше сообщение отправлено!",
    sendError: "Ошибка отправки. Попробуйте снова.",
  },
  ar: {
    heroSubtitle: "يسعدنا سماعك",
    heroTitle: "اتصل بنا",
    sendMessage: "أرسل لنا رسالة",
    fullName: "الاسم الكامل *",
    email: "البريد الإلكتروني *",
    phone: "الهاتف",
    messagePlaceholder: "الرسالة *",
    sending: "جاري الإرسال...",
    send: "إرسال الرسالة",
    privacyNote: "*لا تقلق، يتم حفظ هذه التفاصيل فقط لغرض الاتصال وفقًا لـ",
    privacyPolicy: "سياسة الخصوصية",
    and: "و",
    termsOfUse: "شروط الاستخدام",
    address: "العنوان",
    addressValue: "شارع هرتسل 58، بئر السبع",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
    businessHours: "ساعات العمل",
    sunday: "الأحد",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    fridayHolidays: "الجمعة وعشية الأعياد",
    saturdayHolidays: "السبت والأعياد",
    closed: "مغلق",
    mapTitle: "موقع أليس للمجوهرات",
    nameRequired: "الاسم مطلوب",
    nameMax: "الاسم يجب أن يكون حتى 100 حرف",
    emailRequired: "البريد الإلكتروني مطلوب",
    emailInvalid: "عنوان بريد إلكتروني غير صالح",
    emailMax: "البريد الإلكتروني حتى 255 حرف",
    phoneMax: "الهاتف حتى 20 حرف",
    phoneInvalid: "رقم هاتف غير صالح",
    messageRequired: "الرسالة مطلوبة",
    messageMax: "الرسالة حتى 2000 حرف",
    fixFields: "يرجى تصحيح الحقول المميزة",
    securityFailed: "فشل التحقق الأمني، يرجى تحديث الصفحة",
    messageSent: "تم إرسال رسالتك بنجاح!",
    sendError: "حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.",
  },
};

// ─── About Page ─────────────────────────────────────────
export const about = {
  en: {
    since: "Since 1984", ourStory: "Our Story", tradition: "A Tradition of Excellence",
    storyP1: "In 1984, David and Albert Burmad opened the doors of Alice Jewelry in Beer Sheva, with a simple yet ambitious vision - to bring quality jewelry and excellent service to every customer.",
    storyP2: "Since then, we have become a household name in the world of jewelry in southern Israel. Every piece of jewelry we offer is carefully selected, every customer receives personal attention, and every moment with us is an experience.",
    storyP3: "We believe that a piece of jewelry is more than an accessory - it's a story, a memory, a moment of happiness preserved forever.",
    ourValues: "Our Values", whatGuidesUs: "What Guides Us",
    valuesSubtitle: "These values are the foundation of everything we do",
    inNumbers: "In Numbers", ourSuccess: "Our Success",
    yearFounded: "Year Founded", yearsExperience: "Years of Experience",
    satisfaction: "Satisfaction", happyCustomers: "Happy Customers",
    founding: "Store Founded", foundingDesc: "David and Albert Burmad found Alice Jewelry in Beer Sheva",
    expansion: "Expanding the Range", expansionDesc: "Expanding the luxury jewelry and watch collection",
    leadingSouth: "Leading in the South", leadingSouthDesc: "Becoming the leading jewelry store in the southern region",
    internationalPartners: "International Partnerships", internationalDesc: "Starting collaborations with leading European manufacturers",
    digitalRevolution: "Digital Revolution", digitalDesc: "Launching the new website and transitioning to online sales",
    fortyYears: "40 Years of Excellence", fortyDesc: "Celebrating four decades of service and uncompromising quality",
    uncompromising: "Uncompromising Quality", uncompDesc: "Every piece of jewelry undergoes thorough inspection before reaching you",
    personalService: "Warm Personal Service", personalDesc: "Personal and professional attention to every customer, like family",
    fullWarranty: "Full Warranty", warrantyDesc: "Comprehensive warranty on every product and professional repair service",
    professionalism: "Professionalism & Reliability", profDesc: "Expert team with decades of experience in the field",
    community: "Community & Family", communityDesc: "A family business that treats every customer as a friend",
    innovation: "Innovation & Modernity", innovationDesc: "Always updated with the latest trends from around the world",
    // About homepage section
    aboutAlice: "About Alice", showMore: "Show More", showLess: "Show Less", fullAboutPage: "Full About Page",
    ethicalTitle: "Ethical and Beautiful", ethicalSubtitle: "Quality without bias",
    aboutButton: "About Alice",
    // Contact section in about page
    visitUs: "Visit Us", addressLabel: "Address", phoneLabel: "Phone", emailLabel: "Email",
    hoursLabel: "Business Hours", viewCollections: "View Collections", contactUs: "Contact Us",
    yearsOfExperience: "years of experience",
  },
  ru: {
    since: "С 1984 года", ourStory: "Наша история", tradition: "Традиция мастерства",
    storyP1: "В 1984 году Давид и Альберт Бурмад открыли двери Alice Jewelry в Беэр-Шеве с простой, но амбициозной целью — приносить качественные украшения и отличный сервис каждому клиенту.",
    storyP2: "С тех пор мы стали известным именем в мире ювелирных изделий на юге Израиля. Каждое украшение тщательно отобрано, каждый клиент получает персональное внимание.",
    storyP3: "Мы верим, что украшение — это больше, чем аксессуар. Это история, воспоминание, момент счастья, сохранённый навсегда.",
    ourValues: "Наши ценности", whatGuidesUs: "Что нас направляет",
    valuesSubtitle: "Эти ценности — основа всего, что мы делаем",
    inNumbers: "В цифрах", ourSuccess: "Наш успех",
    yearFounded: "Год основания", yearsExperience: "Лет опыта",
    satisfaction: "Удовлетворённость", happyCustomers: "Довольных клиентов",
    founding: "Основание магазина", foundingDesc: "Давид и Альберт Бурмад основали Alice Jewelry в Беэр-Шеве",
    expansion: "Расширение ассортимента", expansionDesc: "Расширение коллекции роскошных украшений и часов",
    leadingSouth: "Лидеры на юге", leadingSouthDesc: "Становление ведущим ювелирным магазином в южном регионе",
    internationalPartners: "Международные партнёрства", internationalDesc: "Начало сотрудничества с ведущими европейскими производителями",
    digitalRevolution: "Цифровая революция", digitalDesc: "Запуск нового сайта и переход к онлайн-продажам",
    fortyYears: "40 лет мастерства", fortyDesc: "Празднуем четыре десятилетия сервиса и бескомпромиссного качества",
    uncompromising: "Бескомпромиссное качество", uncompDesc: "Каждое украшение проходит тщательную проверку",
    personalService: "Тёплый персональный сервис", personalDesc: "Личное и профессиональное внимание к каждому клиенту",
    fullWarranty: "Полная гарантия", warrantyDesc: "Комплексная гарантия на каждый продукт и профессиональный ремонт",
    professionalism: "Профессионализм и надёжность", profDesc: "Команда экспертов с десятилетиями опыта",
    community: "Сообщество и семейность", communityDesc: "Семейный бизнес, где к каждому клиенту относятся как к другу",
    innovation: "Инновации и современность", innovationDesc: "Всегда в курсе последних мировых трендов",
    aboutAlice: "Об Alice", showMore: "Показать больше", showLess: "Показать меньше", fullAboutPage: "Полная страница о нас",
    ethicalTitle: "Этично и красиво", ethicalSubtitle: "Качество без предубеждений",
    aboutButton: "Об Alice",
    visitUs: "Посетите нас", addressLabel: "Адрес", phoneLabel: "Телефон", emailLabel: "Эл. почта",
    hoursLabel: "Часы работы", viewCollections: "Посмотреть коллекции", contactUs: "Свяжитесь с нами",
    yearsOfExperience: "лет опыта",
  },
  ar: {
    since: "منذ 1984", ourStory: "قصتنا", tradition: "تقليد من التميز",
    storyP1: "في عام 1984، افتتح داود وألبرت بورماد أبواب أليس للمجوهرات في بئر السبع، برؤية بسيطة وطموحة - تقديم مجوهرات عالية الجودة وخدمة ممتازة لكل عميل.",
    storyP2: "منذ ذلك الحين، أصبحنا اسمًا معروفًا في عالم المجوهرات في جنوب إسرائيل. كل قطعة مجوهرات نقدمها يتم اختيارها بعناية، وكل عميل يحصل على اهتمام شخصي.",
    storyP3: "نحن نؤمن أن قطعة المجوهرات هي أكثر من مجرد إكسسوار - إنها قصة، ذكرى، لحظة سعادة محفوظة للأبد.",
    ourValues: "قيمنا", whatGuidesUs: "ما يوجهنا",
    valuesSubtitle: "هذه القيم هي أساس كل ما نقوم به",
    inNumbers: "بالأرقام", ourSuccess: "نجاحنا",
    yearFounded: "سنة التأسيس", yearsExperience: "سنوات خبرة",
    satisfaction: "رضا", happyCustomers: "عملاء سعداء",
    founding: "تأسيس المتجر", foundingDesc: "داود وألبرت بورماد يؤسسان أليس للمجوهرات في بئر السبع",
    expansion: "توسيع المجموعة", expansionDesc: "توسيع مجموعة المجوهرات والساعات الفاخرة",
    leadingSouth: "الرائدون في الجنوب", leadingSouthDesc: "أصبحنا متجر المجوهرات الرائد في المنطقة الجنوبية",
    internationalPartners: "شراكات دولية", internationalDesc: "بدء التعاون مع مصنعين أوروبيين رائدين",
    digitalRevolution: "الثورة الرقمية", digitalDesc: "إطلاق الموقع الجديد والانتقال للمبيعات عبر الإنترنت",
    fortyYears: "40 عامًا من التميز", fortyDesc: "نحتفل بأربعة عقود من الخدمة والجودة بلا تنازلات",
    uncompromising: "جودة بلا تنازلات", uncompDesc: "كل قطعة مجوهرات تخضع لفحص دقيق قبل وصولها إليك",
    personalService: "خدمة شخصية دافئة", personalDesc: "اهتمام شخصي ومهني لكل عميل، مثل العائلة",
    fullWarranty: "ضمان كامل", warrantyDesc: "ضمان شامل على كل منتج وخدمة إصلاح احترافية",
    professionalism: "الاحترافية والموثوقية", profDesc: "فريق خبراء بعقود من الخبرة في المجال",
    community: "المجتمع والعائلة", communityDesc: "عمل عائلي يعامل كل عميل كصديق",
    innovation: "الابتكار والحداثة", innovationDesc: "دائمًا على اطلاع بأحدث الاتجاهات العالمية",
    aboutAlice: "عن أليس", showMore: "عرض المزيد", showLess: "عرض أقل", fullAboutPage: "صفحة نبذة عنا الكاملة",
    ethicalTitle: "أخلاقي وجميل", ethicalSubtitle: "جودة بلا تحيز",
    aboutButton: "عن أليس",
    visitUs: "زورونا", addressLabel: "العنوان", phoneLabel: "الهاتف", emailLabel: "البريد الإلكتروني",
    hoursLabel: "ساعات العمل", viewCollections: "عرض المجموعات", contactUs: "اتصل بنا",
    yearsOfExperience: "سنوات خبرة",
  },
};

// ─── Shipping Page ─────────────────────────────────────────
export const shipping = {
  en: {
    title: "Shipping Policy",
    homeDelivery: "Home Delivery",
    homeDeliveryP1: "Deliveries to remote areas may be delayed up to 12 business days. The list of remote areas can be found on the Israel Post website.",
    homeDeliveryP2: "After the shipment is received by the courier company, they will contact you at the number you provided to schedule the preferred delivery time.",
    homeDeliveryP3: "Deliveries are made Sunday-Thursday 08:00-19:00 and Friday 08:00-12:00. The courier company will contact you to arrange the delivery time.",
    homeDeliveryP4: "For non-remote areas, estimated delivery time is usually 2-5 business days from the order date.",
    selfPickup: "Self Pickup",
    selfPickupP1: "Orders can currently be picked up only at the main branch, 58 Herzl St., Beer Sheva, during business hours.",
    selfPickupP2: "Please come to pick up the order only after receiving an email confirming that the order is ready for pickup.",
    selfPickupP3: "You can also arrange pickup with customer service at 079-5575576 or email: info@alicejewelry.net",
    additionalNotes: "Additional Notes:",
    note1: "Orders received after 3:00 PM or on Friday/holiday eve will be processed the next business day.",
    note2: "Custom-size orders, such as rings (wedding/engagement), delivery time will vary according to the manufacturer's production time. Up to 21 business days.",
    note3: "If there is a delay for any reason, we will make sure to notify you.",
  },
  ru: {
    title: "Политика доставки",
    homeDelivery: "Доставка на дом",
    homeDeliveryP1: "Доставка в отдалённые районы может задерживаться до 12 рабочих дней. Список можно найти на сайте Почты Израиля.",
    homeDeliveryP2: "После получения посылки курьерской компанией с вами свяжутся для согласования времени доставки.",
    homeDeliveryP3: "Доставка: воскресенье-четверг 08:00-19:00, пятница 08:00-12:00.",
    homeDeliveryP4: "Для обычных районов срок доставки обычно 2-5 рабочих дней.",
    selfPickup: "Самовывоз",
    selfPickupP1: "Заказы можно забрать только в главном филиале: ул. Герцля 58, Беэр-Шева, в часы работы.",
    selfPickupP2: "Приходите за заказом только после получения подтверждения по email.",
    selfPickupP3: "Также можно договориться по телефону 079-5575576 или email: info@alicejewelry.net",
    additionalNotes: "Дополнительные примечания:",
    note1: "Заказы после 15:00 или в пятницу/канун праздника обрабатываются на следующий рабочий день.",
    note2: "Заказы по индивидуальным размерам (кольца) — срок до 21 рабочего дня.",
    note3: "В случае задержки мы обязательно вас уведомим.",
  },
  ar: {
    title: "سياسة الشحن",
    homeDelivery: "التوصيل للمنزل",
    homeDeliveryP1: "قد يتأخر التوصيل للمناطق النائية حتى 12 يوم عمل. يمكن العثور على القائمة في موقع بريد إسرائيل.",
    homeDeliveryP2: "بعد استلام شركة التوصيل للشحنة، سيتواصلون معك لتحديد وقت التسليم المفضل.",
    homeDeliveryP3: "التسليم: الأحد-الخميس 08:00-19:00 والجمعة 08:00-12:00.",
    homeDeliveryP4: "للمناطق العادية، وقت التسليم المقدر 2-5 أيام عمل.",
    selfPickup: "الاستلام الذاتي",
    selfPickupP1: "يمكن استلام الطلبات حاليًا فقط من الفرع الرئيسي، شارع هرتسل 58، بئر السبع.",
    selfPickupP2: "يرجى الحضور لاستلام الطلب فقط بعد تلقي تأكيد بالبريد الإلكتروني.",
    selfPickupP3: "يمكنك أيضًا الترتيب عبر الهاتف 079-5575576 أو البريد: info@alicejewelry.net",
    additionalNotes: "ملاحظات إضافية:",
    note1: "الطلبات بعد الساعة 15:00 أو في الجمعة/عشية العيد تُعالج في يوم العمل التالي.",
    note2: "الطلبات بمقاسات مخصصة (خواتم) — حتى 21 يوم عمل.",
    note3: "في حالة التأخير سنحرص على إبلاغكم.",
  },
};

// ─── Returns Page ─────────────────────────────────────────
export const returns = {
  en: {
    title: "Returns & Cancellation Policy",
    subtitle: "Cancellation in accordance with Consumer Protection Law 1981 and product return policy",
    returnTitle: "Return & Cancellation",
    returnDesc: "Return the jewelry and cancel the transaction with the invoice and warranty within two days of purchase.",
    under3000Title: "Transactions up to ₪3,000",
    under3000Desc: "A jewelry purchase transaction up to ₪3,000 can be cancelled from the date of purchase until the end of two non-rest days after.",
    over3000Title: "Transactions over ₪3,000",
    over3000Desc: "Over ₪3,000, only store credit will be given for returning the jewelry within two days of purchase.",
    deadlineTitle: "Cancellation Deadline",
    deadlineDesc: "The transaction can be cancelled from the date of purchase until the end of two non-rest days after.",
    cancellationFee: "Cancellation Fee (Regret)",
    cancellationFeeDesc: "5% or ₪100, whichever is lower.",
    exchangeTitle: "Jewelry Exchange",
    exchangeDesc: "Exchange the jewelry with invoice and warranty within 14 days of purchase (not including rest days).",
    specialConditions: "Special Conditions",
    condition1: "Cancellation does not apply to custom/special order jewelry. No cash refund will be given.",
    condition2: "Jewelry made with custom design or modifications to existing stock — no refund/cash return.",
    condition3: "Return shipping costs are borne by the customer.",
    condition4: "Jewelry comes with a tag; removing the tag cancels cash refund — only exchange credit within 14 days.",
    condition5: "The company is not responsible for loss/damage to the central diamond (insurance recommended).",
    warrantyTitle: "Warranty",
    warrantyDesc: "One year warranty from purchase date. Warranty is void if improper use is made of the jewelry.",
  },
  ru: {
    title: "Политика возвратов и отмены",
    subtitle: "Отмена сделки в соответствии с Законом о защите прав потребителей 1981 года",
    returnTitle: "Возврат и отмена",
    returnDesc: "Возврат украшения и отмена сделки с чеком и гарантией в течение двух дней после покупки.",
    under3000Title: "Сделки до ₪3,000",
    under3000Desc: "Покупку украшения до ₪3,000 можно отменить в течение двух рабочих дней.",
    over3000Title: "Сделки свыше ₪3,000",
    over3000Desc: "Свыше ₪3,000 — только кредит магазина при возврате в течение двух дней.",
    deadlineTitle: "Крайний срок отмены",
    deadlineDesc: "Сделку можно отменить в течение двух рабочих дней после покупки.",
    cancellationFee: "Плата за отмену (по желанию)",
    cancellationFeeDesc: "5% или ₪100, что меньше.",
    exchangeTitle: "Обмен украшений",
    exchangeDesc: "Обмен с чеком и гарантией в течение 14 дней (без выходных).",
    specialConditions: "Особые условия",
    condition1: "Отмена не распространяется на индивидуальные заказы.",
    condition2: "Украшения с индивидуальным дизайном — без возврата.",
    condition3: "Стоимость обратной доставки оплачивается покупателем.",
    condition4: "Снятие бирки отменяет денежный возврат — только кредит на обмен.",
    condition5: "Компания не несёт ответственности за потерю/повреждение центрального бриллианта.",
    warrantyTitle: "Гарантия",
    warrantyDesc: "Гарантия один год с даты покупки. Не действует при ненадлежащем использовании.",
  },
  ar: {
    title: "سياسة الإرجاع والإلغاء",
    subtitle: "الإلغاء وفقًا لقانون حماية المستهلك 1981 وسياسة إرجاع المنتجات",
    returnTitle: "الإرجاع والإلغاء",
    returnDesc: "إرجاع المجوهرات وإلغاء المعاملة مع الفاتورة والضمان خلال يومين من الشراء.",
    under3000Title: "معاملات حتى ₪3,000",
    under3000Desc: "يمكن إلغاء شراء مجوهرات حتى ₪3,000 خلال يومي عمل.",
    over3000Title: "معاملات فوق ₪3,000",
    over3000Desc: "فوق ₪3,000 — رصيد متجر فقط عند الإرجاع خلال يومين.",
    deadlineTitle: "الموعد النهائي للإلغاء",
    deadlineDesc: "يمكن إلغاء المعاملة خلال يومي عمل بعد الشراء.",
    cancellationFee: "رسوم الإلغاء",
    cancellationFeeDesc: "5% أو ₪100، أيهما أقل.",
    exchangeTitle: "استبدال المجوهرات",
    exchangeDesc: "الاستبدال مع الفاتورة والضمان خلال 14 يومًا (بدون أيام الراحة).",
    specialConditions: "شروط خاصة",
    condition1: "الإلغاء لا ينطبق على الطلبات المخصصة.",
    condition2: "مجوهرات بتصميم مخصص — بدون استرداد.",
    condition3: "تكاليف شحن الإرجاع يتحملها العميل.",
    condition4: "إزالة العلامة تلغي الاسترداد النقدي — رصيد استبدال فقط.",
    condition5: "الشركة غير مسؤولة عن فقدان/تلف الماسة المركزية.",
    warrantyTitle: "الضمان",
    warrantyDesc: "ضمان سنة واحدة من تاريخ الشراء. لا يسري في حالة الاستخدام غير السليم.",
  },
};

// ─── Privacy, Terms, Accessibility, TradeIn, GiftCard, TrackOrder, FAQ, RingSizeGuide, CookiePolicy ───
export const pages = {
  en: {
    // Page titles
    privacyTitle: "Privacy Policy", termsTitle: "Terms of Use",
    accessibilityTitle: "Accessibility Statement", tradeInTitle: "Alice Trade-In",
    giftCardTitle: "Gift Card", trackOrderTitle: "Repair Tracking",
    faqTitle: "Frequently Asked Questions", ringSizeGuideTitle: "Ring Size Guide",
    cookiePolicyTitle: "Cookie Policy",
    // FAQ
    faqSubtitle: "Find answers to the most common questions",
    noFaqQuestions: "No FAQ questions to display at this time",
    noQuestionsInCategory: "No questions in this category",
    faqNotFound: "Didn't find an answer to your question?",
    faqContactUs: "Contact us and we'll be happy to help",
    faqContactButton: "Contact Us",
    // Gift Card
    giftCardSubtitle: "Give someone you love the option to choose the perfect jewelry piece",
    chooseAmount: "Choose an amount",
    afterPurchase: "After purchase, the gift card code will be sent to your email",
    selectedAmount: "Selected amount",
    addToCart: "Add to Cart",
    giftCardInfo1: "The gift card will be sent to your email immediately after purchase",
    giftCardInfo2: "The gift card can only be redeemed for online purchases",
    giftCardInfo3: "The gift card has no expiration date",
    giftCardUnavailable: "The gift card is currently unavailable",
    giftCardAdded: "Gift card added to cart",
    // Track Order
    enterPhone: "Enter your phone number",
    wellSendCode: "We'll send you a verification code",
    phoneNumber: "Phone number",
    sendCode: "Send me a verification code",
    sendingCode: "Sending code...",
    haveAccount: "Have an account?",
    loginHere: "Login here",
    howItWorks: "How does it work?",
    step1Title: "Enter phone number",
    step1Desc: "The phone number appears on the receipt you received",
    step2Title: "Verify identity",
    step2Desc: "Enter the verification code sent to you",
    step3Title: "View orders",
    step3Desc: "Track the status in real time",
    enterOtp: "Enter verification code",
    codeSentTo: "Verification code sent to",
    verifying: "Verifying...",
    sendNewCode: "Send new code",
    changePhone: "Change phone number",
    createAccount: "Create an account and get benefits!",
    createAccountDesc: "Join us and get updates, exclusive discounts and easier tracking",
    toPersonalArea: "To personal area",
    noRepairs: "No repairs found",
    noRepairsDesc: "No repair or delivery tracking orders were found for this phone number",
    startOver: "Start over",
    repairNumber: "Repair #",
    lastUpdate: "Last update",
    created: "Created",
    // Trade-In
    tradeInSubtitle: "Your unused gold is worth money!",
    tradeInDesc: "At Alice, we allow you to exchange your broken or unused gold jewelry for a new, shiny and modern gold piece through our Trade-In program.",
    tradeInHowTo: "So what do you do?",
    tradeInHowToDesc: "Simply come to one of our stores with the old gold, we'll weigh it, perform several value assessments and give you the option to receive store credit or cash!",
    tradeInParams: "Parameters we check in store:",
    tradeInParam1: "Current gold rate on the exchange",
    tradeInParam2: "Gold weight",
    tradeInParam3: "Carat type",
    tradeInNote: "During these checks, the sales representative may request the customer's approval to remove stones from the returned jewelry for net gold weighing.",
    tradeInCTA: "Already weighed your gold and want a value estimate?",
    tradeInContact: "Contact us or call customer service:",
    // Ring Size Guide
    ringSizeNote: "Important: Ring size varies from right hand to left hand and depends on weather and finger effort before measurement. Measure after rest in reasonable weather.",
    ringSizeTools: "Required tools:",
    ringSizeThread: "Thread",
    ringSizeRuler: "Ruler",
    ringSizeFinger: "Finger",
    haveRing: "Already have a ring?",
    haveRingDesc: "If you already have a ring and want to find its size, you can use the size finder app:",
    downloadAndroid: "Download for Android, click here!",
    downloadIphone: "Download for iPhone, click here!",
    letsStart: "OK, let's start:",
    step1Ring: "With a sewing thread, wrap around the desired finger at its thickest part.",
    step2Ring: "Mark with a pen the spot on the thread that represents the finger circumference.",
    step3Ring: "Place the thread on a ruler, check the length to the marked area and compare with the table below:",
    sizeTable: "Size Table",
    circumferenceMM: "Size by circumference in mm",
    sizeByNumber: "Size by number",
    // Cookie Policy
    cookieWhat: "What are cookies?",
    cookieWhatDesc: "Cookies are small text files stored on your device when you visit a website. They allow the site to remember your actions and preferences over time.",
    cookieTypes: "Types of cookies we use",
    cookieNecessary: "Necessary Cookies",
    cookieNecessaryDesc: "Essential for the basic functioning of the website. They enable navigation, access to secure areas, shopping cart, and login.",
    cookieAlwaysActive: "Always active • Cannot be disabled",
    cookieAnalytics: "Statistics & Analytics Cookies",
    cookieAnalyticsDesc: "Help us understand how visitors use the site by collecting anonymous statistical information.",
    cookieMarketing: "Marketing & Advertising Cookies",
    cookieMarketingDesc: "Used to display relevant ads and track campaign effectiveness.",
    cookieFunctional: "Functional Cookies",
    cookieFunctionalDesc: "Enable advanced features like language preferences, video viewing, and social media integration.",
    cookieManage: "How to manage your cookies?",
    cookieManageDesc: "You have full control over cookies stored on your device:",
    cookieManageVia: "Via our site: Click the 'Manage Preferences' button at the top of this page.",
    cookieManageBrowser: "Via your browser: Most browsers allow you to view, delete and block cookies.",
    cookieThirdParty: "Third Party Providers",
    cookieThirdPartyDesc: "We work with trusted third-party providers for analytics and marketing:",
    cookieUpdates: "Policy Updates",
    cookieUpdatesDesc: "We may update this policy from time to time. Any material changes will be published on this page.",
    cookieLastUpdate: "Last update: December 2025",
    cookieContactTitle: "Contact",
    cookieContactDesc: "If you have questions about our use of cookies, please contact us:",
    managePreferences: "Manage my cookie preferences",
    // Providers
    providers: "Providers",
  },
  ru: {
    privacyTitle: "Политика конфиденциальности", termsTitle: "Условия использования",
    accessibilityTitle: "Заявление о доступности", tradeInTitle: "Alice Trade-In",
    giftCardTitle: "Подарочная карта", trackOrderTitle: "Отслеживание ремонта",
    faqTitle: "Часто задаваемые вопросы", ringSizeGuideTitle: "Гид по размерам колец",
    cookiePolicyTitle: "Политика cookies",
    faqSubtitle: "Найдите ответы на самые частые вопросы",
    noFaqQuestions: "Нет вопросов для отображения", noQuestionsInCategory: "Нет вопросов в этой категории",
    faqNotFound: "Не нашли ответ на свой вопрос?",
    faqContactUs: "Свяжитесь с нами, и мы будем рады помочь", faqContactButton: "Связаться",
    giftCardSubtitle: "Подарите любимым возможность выбрать идеальное украшение",
    chooseAmount: "Выберите сумму", afterPurchase: "После покупки код карты будет отправлен на вашу почту",
    selectedAmount: "Выбранная сумма", addToCart: "Добавить в корзину",
    giftCardInfo1: "Карта будет отправлена на email сразу после покупки",
    giftCardInfo2: "Карту можно использовать только для покупок на сайте",
    giftCardInfo3: "Подарочная карта бессрочная", giftCardUnavailable: "Подарочная карта недоступна",
    giftCardAdded: "Подарочная карта добавлена в корзину",
    enterPhone: "Введите номер телефона", wellSendCode: "Мы отправим вам код подтверждения",
    phoneNumber: "Номер телефона", sendCode: "Отправить код", sendingCode: "Отправка...",
    haveAccount: "Есть аккаунт?", loginHere: "Войдите здесь",
    howItWorks: "Как это работает?",
    step1Title: "Введите номер телефона", step1Desc: "Номер указан в квитанции",
    step2Title: "Подтвердите личность", step2Desc: "Введите код подтверждения",
    step3Title: "Просмотрите заказы", step3Desc: "Отслеживайте статус в реальном времени",
    enterOtp: "Введите код подтверждения", codeSentTo: "Код отправлен на",
    verifying: "Проверяем...", sendNewCode: "Отправить новый код", changePhone: "Изменить номер",
    createAccount: "Создайте аккаунт и получите бонусы!",
    createAccountDesc: "Присоединяйтесь и получайте обновления и скидки",
    toPersonalArea: "В личный кабинет",
    noRepairs: "Ремонты не найдены", noRepairsDesc: "Для этого номера не найдено заказов",
    startOver: "Начать заново", repairNumber: "Ремонт #", lastUpdate: "Последнее обновление", created: "Создано",
    tradeInSubtitle: "Ваше неиспользуемое золото стоит денег!",
    tradeInDesc: "В Alice мы позволяем обменять старые или сломанные золотые украшения на новые через программу Trade-In.",
    tradeInHowTo: "Что нужно сделать?",
    tradeInHowToDesc: "Приходите в магазин со старым золотом, мы взвесим его, оценим и предложим кредит или наличные!",
    tradeInParams: "Параметры, которые мы проверяем:", tradeInParam1: "Текущий курс золота",
    tradeInParam2: "Вес золота", tradeInParam3: "Тип карата",
    tradeInNote: "При проверке может потребоваться согласие на извлечение камней для взвешивания чистого золота.",
    tradeInCTA: "Уже взвесили золото? Хотите оценку?", tradeInContact: "Свяжитесь с нами:",
    ringSizeNote: "Важно: размер варьируется между руками и зависит от погоды. Измеряйте в покое.",
    ringSizeTools: "Необходимые инструменты:", ringSizeThread: "Нитка", ringSizeRuler: "Линейка", ringSizeFinger: "Палец",
    haveRing: "Уже есть кольцо?", haveRingDesc: "Используйте приложение для определения размера:",
    downloadAndroid: "Скачать для Android", downloadIphone: "Скачать для iPhone",
    letsStart: "Начинаем:", step1Ring: "Оберните нитку вокруг пальца в самом широком месте.",
    step2Ring: "Отметьте место на нитке.", step3Ring: "Измерьте длину и сравните с таблицей:",
    sizeTable: "Таблица размеров", circumferenceMM: "Размер по окружности (мм)", sizeByNumber: "Размер по номеру",
    cookieWhat: "Что такое cookies?",
    cookieWhatDesc: "Cookies — небольшие текстовые файлы, сохраняемые на вашем устройстве при посещении сайта.",
    cookieTypes: "Типы cookies", cookieNecessary: "Необходимые cookies",
    cookieNecessaryDesc: "Необходимы для базовой работы сайта.",
    cookieAlwaysActive: "Всегда активны • Нельзя отключить",
    cookieAnalytics: "Аналитические cookies", cookieAnalyticsDesc: "Помогают понять, как посетители используют сайт.",
    cookieMarketing: "Маркетинговые cookies", cookieMarketingDesc: "Для показа релевантной рекламы.",
    cookieFunctional: "Функциональные cookies", cookieFunctionalDesc: "Для расширенных функций и настроек.",
    cookieManage: "Как управлять cookies?", cookieManageDesc: "У вас полный контроль:",
    cookieManageVia: "Через наш сайт: кнопка 'Управление настройками'.",
    cookieManageBrowser: "Через браузер: большинство позволяют управлять cookies.",
    cookieThirdParty: "Сторонние провайдеры", cookieThirdPartyDesc: "Мы работаем с надёжными партнёрами:",
    cookieUpdates: "Обновления политики", cookieUpdatesDesc: "Мы можем обновлять эту политику.",
    cookieLastUpdate: "Последнее обновление: декабрь 2025",
    cookieContactTitle: "Контакт", cookieContactDesc: "Если у вас есть вопросы о cookies:",
    managePreferences: "Управление настройками cookies", providers: "Провайдеры",
  },
  ar: {
    privacyTitle: "سياسة الخصوصية", termsTitle: "شروط الاستخدام",
    accessibilityTitle: "بيان إمكانية الوصول", tradeInTitle: "Alice Trade-In",
    giftCardTitle: "بطاقة هدايا", trackOrderTitle: "تتبع الإصلاح",
    faqTitle: "الأسئلة الشائعة", ringSizeGuideTitle: "دليل مقاسات الخواتم",
    cookiePolicyTitle: "سياسة ملفات تعريف الارتباط",
    faqSubtitle: "ابحث عن إجابات للأسئلة الأكثر شيوعًا",
    noFaqQuestions: "لا توجد أسئلة للعرض حاليًا", noQuestionsInCategory: "لا توجد أسئلة في هذه الفئة",
    faqNotFound: "لم تجد إجابة لسؤالك؟",
    faqContactUs: "تواصل معنا وسنسعد بمساعدتك", faqContactButton: "اتصل بنا",
    giftCardSubtitle: "امنح من تحب فرصة اختيار قطعة المجوهرات المثالية",
    chooseAmount: "اختر المبلغ", afterPurchase: "بعد الشراء، سيتم إرسال رمز البطاقة إلى بريدك",
    selectedAmount: "المبلغ المختار", addToCart: "أضف إلى السلة",
    giftCardInfo1: "سيتم إرسال البطاقة فورًا بعد الشراء",
    giftCardInfo2: "يمكن استخدام البطاقة للشراء عبر الإنترنت فقط",
    giftCardInfo3: "بطاقة الهدايا غير محدودة الصلاحية", giftCardUnavailable: "بطاقة الهدايا غير متوفرة حاليًا",
    giftCardAdded: "تمت إضافة بطاقة الهدايا إلى السلة",
    enterPhone: "أدخل رقم هاتفك", wellSendCode: "سنرسل لك رمز التحقق",
    phoneNumber: "رقم الهاتف", sendCode: "أرسل لي رمز التحقق", sendingCode: "جاري الإرسال...",
    haveAccount: "لديك حساب؟", loginHere: "سجّل الدخول هنا",
    howItWorks: "كيف يعمل؟",
    step1Title: "أدخل رقم الهاتف", step1Desc: "الرقم موجود في الإيصال",
    step2Title: "أكّد هويتك", step2Desc: "أدخل رمز التحقق",
    step3Title: "اعرض الطلبات", step3Desc: "تتبع الحالة في الوقت الفعلي",
    enterOtp: "أدخل رمز التحقق", codeSentTo: "تم إرسال رمز التحقق إلى",
    verifying: "جاري التحقق...", sendNewCode: "إرسال رمز جديد", changePhone: "تغيير رقم الهاتف",
    createAccount: "أنشئ حسابًا واحصل على مزايا!",
    createAccountDesc: "انضم إلينا واحصل على تحديثات وخصومات حصرية",
    toPersonalArea: "إلى المنطقة الشخصية",
    noRepairs: "لم يتم العثور على إصلاحات", noRepairsDesc: "لم يتم العثور على طلبات لهذا الرقم",
    startOver: "ابدأ من جديد", repairNumber: "إصلاح #", lastUpdate: "آخر تحديث", created: "تم الإنشاء",
    tradeInSubtitle: "ذهبك غير المستخدم يستحق المال!",
    tradeInDesc: "في أليس، نتيح لك استبدال مجوهراتك الذهبية القديمة أو المكسورة بقطعة جديدة من خلال برنامج Trade-In.",
    tradeInHowTo: "ماذا تفعل؟",
    tradeInHowToDesc: "تعال إلى المتجر مع الذهب القديم، سنزنه ونقيّمه ونعطيك خيار الحصول على رصيد أو نقد!",
    tradeInParams: "المعايير التي نفحصها:", tradeInParam1: "سعر الذهب الحالي",
    tradeInParam2: "وزن الذهب", tradeInParam3: "نوع القيراط",
    tradeInNote: "قد يُطلب موافقة لإزالة الأحجار لوزن الذهب الصافي.",
    tradeInCTA: "وزنت ذهبك وتريد تقييمًا؟", tradeInContact: "تواصل معنا:",
    ringSizeNote: "مهم: المقاس يختلف بين اليدين ويعتمد على الطقس. قس بعد الراحة.",
    ringSizeTools: "الأدوات المطلوبة:", ringSizeThread: "خيط", ringSizeRuler: "مسطرة", ringSizeFinger: "إصبع",
    haveRing: "لديك خاتم بالفعل؟", haveRingDesc: "استخدم تطبيق تحديد المقاس:",
    downloadAndroid: "تحميل لأندرويد", downloadIphone: "تحميل لآيفون",
    letsStart: "لنبدأ:", step1Ring: "لف خيطًا حول الإصبع في أعرض نقطة.",
    step2Ring: "ضع علامة على الخيط.", step3Ring: "قس الطول وقارن بالجدول:",
    sizeTable: "جدول المقاسات", circumferenceMM: "المقاس حسب المحيط (مم)", sizeByNumber: "المقاس حسب الرقم",
    cookieWhat: "ما هي ملفات تعريف الارتباط؟",
    cookieWhatDesc: "ملفات تعريف الارتباط هي ملفات نصية صغيرة تُخزن على جهازك عند زيارة موقع.",
    cookieTypes: "أنواع ملفات تعريف الارتباط", cookieNecessary: "ملفات ضرورية",
    cookieNecessaryDesc: "ضرورية لعمل الموقع الأساسي.",
    cookieAlwaysActive: "نشطة دائمًا • لا يمكن تعطيلها",
    cookieAnalytics: "ملفات إحصائية", cookieAnalyticsDesc: "تساعدنا في فهم كيفية استخدام الزوار للموقع.",
    cookieMarketing: "ملفات تسويقية", cookieMarketingDesc: "لعرض إعلانات ذات صلة.",
    cookieFunctional: "ملفات وظيفية", cookieFunctionalDesc: "لميزات متقدمة وتفضيلات.",
    cookieManage: "كيف تدير ملفات تعريف الارتباط؟", cookieManageDesc: "لديك سيطرة كاملة:",
    cookieManageVia: "عبر موقعنا: زر 'إدارة التفضيلات'.",
    cookieManageBrowser: "عبر المتصفح: معظم المتصفحات تتيح إدارتها.",
    cookieThirdParty: "مقدمو خدمات طرف ثالث", cookieThirdPartyDesc: "نعمل مع شركاء موثوقين:",
    cookieUpdates: "تحديثات السياسة", cookieUpdatesDesc: "قد نحدث هذه السياسة من وقت لآخر.",
    cookieLastUpdate: "آخر تحديث: ديسمبر 2025",
    cookieContactTitle: "اتصل بنا", cookieContactDesc: "إذا كانت لديك أسئلة حول ملفات تعريف الارتباط:",
    managePreferences: "إدارة تفضيلات ملفات تعريف الارتباط", providers: "مقدمو الخدمات",
  },
};

// ─── Privacy Page ─────────────────────────────────────────
export const privacy = {
  en: {
    title: "Privacy Policy", companyName: "Alice Jewelry Ltd.",
    intro: "This privacy policy (\"Privacy Policy\") is an integral part of the terms of use and should be read together with the terms of use, using the definitions appearing in the terms of use.",
    siteDescription: "The website \"www.alisjewelry.co.il\" (\"the Site\") operated and managed by Alice Jewelry Ltd., Company No. 514849876 (\"the Operator\") serves, among other things, for online commerce for the purchase of products by visitors and users of the site (\"the Service\") and for customers who register and use the Operator's services.",
    generalTitle: "General",
    generalP1: "As part of using the site's services, the user is required to provide personal details to the Operator including name, address, phone and email, ID number. These details are stored by the Operator in its customer database and are used for internal purposes and future communication with customers.",
    generalP2: "Additional details, such as credit card details, are required for billing purposes only and are not stored by the Operator.",
    databaseTitle: "Database and Its Use",
    databaseDesc: "The data collected about the user is stored in the Operator's database. The Operator undertakes to use said information in accordance with this privacy policy and/or in accordance with any applicable law.",
    cookiesTitle: "Use of Cookies",
    cookiesDesc: "The Operator uses various technologies to collect information from the user's mobile device and/or computer and about the user's activity on the site. Most browsers accept cookies automatically, but the user can usually change their browser settings.",
    securityTitle: "Information Security",
    securityDesc: "The Operator implements up-to-date information security systems and procedures on the site. These systems and procedures reduce the risks of unauthorized access, but do not provide absolute security.",
    changesTitle: "Changes to Privacy Policy",
    changesDesc: "The Operator may change the provisions of this privacy policy from time to time. If material changes are made, a notice will be published on the Operator's website.",
  },
  ru: {
    title: "Политика конфиденциальности", companyName: "Алис Ювелирные изделия ООО",
    intro: "Данная политика конфиденциальности является неотъемлемой частью условий использования и должна читаться совместно с условиями использования.",
    siteDescription: "Веб-сайт «www.alisjewelry.co.il» управляется компанией Алис Ювелирные изделия ООО и служит для онлайн-торговли и обслуживания клиентов.",
    generalTitle: "Общие положения",
    generalP1: "При использовании услуг сайта пользователь должен предоставить личные данные: имя, адрес, телефон, email и номер удостоверения личности. Эти данные хранятся в базе данных клиентов.",
    generalP2: "Дополнительные данные, такие как данные кредитной карты, требуются только для оплаты и не хранятся оператором.",
    databaseTitle: "База данных и её использование",
    databaseDesc: "Собранные данные хранятся в базе данных оператора. Оператор обязуется использовать информацию в соответствии с данной политикой и действующим законодательством.",
    cookiesTitle: "Использование файлов Cookie",
    cookiesDesc: "Оператор использует различные технологии для сбора информации с устройства пользователя. Большинство браузеров принимают cookies автоматически, но пользователь может изменить настройки.",
    securityTitle: "Безопасность информации",
    securityDesc: "Оператор применяет современные системы безопасности. Эти системы снижают риски несанкционированного доступа, но не обеспечивают абсолютную безопасность.",
    changesTitle: "Изменения в политике конфиденциальности",
    changesDesc: "Оператор может время от времени изменять положения данной политики. О существенных изменениях будет опубликовано уведомление на сайте.",
  },
  ar: {
    title: "سياسة الخصوصية", companyName: "أليس للمجوهرات م.ض",
    intro: "سياسة الخصوصية هذه جزء لا يتجزأ من شروط الاستخدام ويجب قراءتها مع شروط الاستخدام.",
    siteDescription: "موقع الإنترنت يُدار من قبل شركة أليس للمجوهرات ويُستخدم للتجارة الإلكترونية وخدمة العملاء.",
    generalTitle: "عام",
    generalP1: "يُطلب من المستخدم تقديم بيانات شخصية تشمل الاسم والعنوان والهاتف والبريد الإلكتروني ورقم الهوية. يتم حفظ هذه البيانات في قاعدة بيانات العملاء.",
    generalP2: "تفاصيل إضافية مثل بيانات بطاقة الائتمان مطلوبة فقط لأغراض الفوترة ولا يتم تخزينها.",
    databaseTitle: "قاعدة البيانات واستخدامها",
    databaseDesc: "يتم تخزين البيانات المجمعة في قاعدة بيانات المشغل. يلتزم المشغل باستخدام المعلومات وفقًا لسياسة الخصوصية والقانون المعمول به.",
    cookiesTitle: "استخدام ملفات تعريف الارتباط (Cookies)",
    cookiesDesc: "يستخدم المشغل تقنيات مختلفة لجمع المعلومات من جهاز المستخدم. معظم المتصفحات تقبل ملفات تعريف الارتباط تلقائيًا، لكن يمكن للمستخدم تغيير الإعدادات.",
    securityTitle: "أمن المعلومات",
    securityDesc: "يطبق المشغل أنظمة وإجراءات أمن معلومات حديثة. هذه الأنظمة تقلل المخاطر لكنها لا توفر أمانًا مطلقًا.",
    changesTitle: "تغييرات في سياسة الخصوصية",
    changesDesc: "يحق للمشغل تغيير أحكام سياسة الخصوصية من وقت لآخر. سيتم نشر إشعار بالتغييرات الجوهرية على الموقع.",
  },
};

// ─── Terms Page ─────────────────────────────────────────
export const terms = {
  en: {
    title: "Terms of Use",
    generalTitle: "General", generalDesc: "Welcome to Alice Jewelry and Watches website. Use of this site is subject to the terms of use detailed below. By browsing the site and/or making a purchase, you confirm that you have read and agree to these terms.",
    aboutTitle: "About Alice Jewelry", aboutDesc: "Alice Jewelry and Watches was founded in 1984 by owners David Burmad and his brother Albert Burmad. The store is named after David's wife, Alice Burmad. Alice started with selling watches and gold jewelry, and over the years grew to become the leading jewelry chain in the south.",
    purchaseTitle: "Purchase and Payment",
    purchaseItem1: "All prices on the site are in New Israeli Shekel and include VAT",
    purchaseItem2: "Prices are valid at the time of publication and may change without prior notice",
    purchaseItem3: "Payment will be made using recognized credit cards or other payment methods offered on the site",
    purchaseItem4: "We reserve the right to cancel an order in case of a price or product description error",
    shippingTitle: "Shipping", shippingDesc: "Deliveries are made through recognized courier companies throughout the country. Estimated delivery time is 3-7 business days from the order date. Shipping cost will appear on the payment page before completing the order.",
    copyrightTitle: "Copyright and Intellectual Property", copyrightDesc: "All content, images, logos and designs on the site are the property of Alice Jewelry or its business partners and are protected by copyright. Copying, reproducing, distributing or commercial use of this content without prior written permission is prohibited.",
    privacyTitle: "Privacy and Information Security", privacyDesc: "We are committed to protecting your personal information. Information collected on the site will be used solely for the purposes detailed in our privacy policy. We employ advanced security measures to protect your personal information.",
    liabilityTitle: "Limitation of Liability", liabilityP1: "Alice Jewelry will not be liable for any direct or indirect damage arising from use of the site or reliance on information displayed on it.", liabilityP2: "We make every effort to display products as accurately as possible, but there may be slight differences between displayed images and the actual product.",
    changesTitle: "Changes to Terms of Use", changesDesc: "Alice Jewelry reserves the right to update and change the terms of use from time to time without prior notice. Continued use of the site after changes constitutes agreement to the updated terms.",
    contactTitle: "Contact Us", contactDesc: "For any question or inquiry regarding the terms of use, you may contact us through the contact page on the site or through the contact details in the footer.",
    jurisdictionTitle: "Jurisdiction", jurisdictionDesc: "These terms of use shall be governed exclusively by the laws of the State of Israel. Exclusive jurisdiction shall be vested in the competent courts in the Southern District.",
  },
  ru: {
    title: "Условия использования",
    generalTitle: "Общие положения", generalDesc: "Добро пожаловать на сайт Алис Ювелирные изделия и Часы. Используя сайт, вы подтверждаете, что прочитали и согласны с условиями использования.",
    aboutTitle: "Об Алис Ювелирные изделия", aboutDesc: "Алис Ювелирные изделия и Часы была основана в 1984 году. За годы компания стала ведущей ювелирной сетью на юге.",
    purchaseTitle: "Покупка и оплата",
    purchaseItem1: "Все цены указаны в шекелях и включают НДС",
    purchaseItem2: "Цены актуальны на момент публикации и могут изменяться",
    purchaseItem3: "Оплата производится кредитными картами или другими способами",
    purchaseItem4: "Мы оставляем за собой право отменить заказ при ошибке в цене",
    shippingTitle: "Доставка", shippingDesc: "Доставка осуществляется курьерскими компаниями по всей стране. Ориентировочный срок — 3-7 рабочих дней.",
    copyrightTitle: "Авторские права", copyrightDesc: "Весь контент, изображения и дизайн защищены авторским правом. Копирование без разрешения запрещено.",
    privacyTitle: "Конфиденциальность и безопасность", privacyDesc: "Мы обязуемся защищать ваши персональные данные. Мы используем передовые средства защиты.",
    liabilityTitle: "Ограничение ответственности", liabilityP1: "Алис Ювелирные изделия не несёт ответственности за прямой или косвенный ущерб.", liabilityP2: "Мы стараемся точно отображать товары, но возможны незначительные отличия.",
    changesTitle: "Изменения условий", changesDesc: "Алис оставляет за собой право изменять условия без предварительного уведомления.",
    contactTitle: "Связаться с нами", contactDesc: "По вопросам об условиях использования свяжитесь через страницу контактов.",
    jurisdictionTitle: "Юрисдикция", jurisdictionDesc: "Настоящие условия регулируются законодательством Израиля. Юрисдикция принадлежит судам Южного округа.",
  },
  ar: {
    title: "شروط الاستخدام",
    generalTitle: "عام", generalDesc: "مرحبًا بكم في موقع أليس للمجوهرات والساعات. باستخدام الموقع فإنك توافق على شروط الاستخدام.",
    aboutTitle: "عن أليس للمجوهرات", aboutDesc: "تأسست أليس للمجوهرات والساعات عام 1984 ونمت لتصبح سلسلة المجوهرات الرائدة في الجنوب.",
    purchaseTitle: "الشراء والدفع",
    purchaseItem1: "جميع الأسعار بالشيكل وتشمل ضريبة القيمة المضافة",
    purchaseItem2: "الأسعار صالحة وقت النشر وقابلة للتغيير",
    purchaseItem3: "يتم الدفع ببطاقات الائتمان أو وسائل دفع أخرى",
    purchaseItem4: "نحتفظ بالحق في إلغاء الطلب في حالة خطأ في السعر",
    shippingTitle: "الشحن", shippingDesc: "يتم التوصيل عبر شركات شحن معتمدة. مدة التسليم المقدرة 3-7 أيام عمل.",
    copyrightTitle: "حقوق النشر والملكية الفكرية", copyrightDesc: "جميع المحتويات والتصاميم محمية بحقوق النشر. يُمنع النسخ دون إذن مكتوب.",
    privacyTitle: "الخصوصية وأمن المعلومات", privacyDesc: "نلتزم بحماية معلوماتك الشخصية ونستخدم وسائل أمان متقدمة.",
    liabilityTitle: "تحديد المسؤولية", liabilityP1: "لا تتحمل أليس المسؤولية عن أي ضرر مباشر أو غير مباشر.", liabilityP2: "نبذل كل جهد لعرض المنتجات بدقة، لكن قد تكون هناك فروقات طفيفة.",
    changesTitle: "تغييرات في الشروط", changesDesc: "تحتفظ أليس بالحق في تحديث الشروط دون إشعار مسبق.",
    contactTitle: "اتصل بنا", contactDesc: "لأي استفسار حول شروط الاستخدام، يمكنكم التواصل عبر صفحة الاتصال.",
    jurisdictionTitle: "الاختصاص القضائي", jurisdictionDesc: "تخضع هذه الشروط حصريًا لقوانين دولة إسرائيل.",
  },
};

// ─── GiftCard Page ─────────────────────────────────────────
export const giftCard = {
  en: {
    title: "Gift Card", heroDesc: "Alice's gift card gives your loved ones the option to choose the perfect jewelry for them",
    chooseAmount: "Choose an amount", afterPurchase: "After purchase, the gift card code will be sent to your email",
    selectedAmount: "Selected amount", addToCart: "Add to Cart",
    info1: "The gift card will be sent to your email immediately after purchase",
    info2: "The gift card can be redeemed for payment on the website only",
    info3: "The gift card has no expiration date",
    notAvailable: "The gift card is currently unavailable",
    addedToCart: "Gift card added to cart",
  },
  ru: {
    title: "Подарочная карта", heroDesc: "Подарочная карта Алис даст вашим близким возможность выбрать идеальное украшение",
    chooseAmount: "Выберите сумму", afterPurchase: "После покупки код подарочной карты будет отправлен на ваш email",
    selectedAmount: "Выбранная сумма", addToCart: "Добавить в корзину",
    info1: "Подарочная карта будет отправлена на ваш email сразу после покупки",
    info2: "Подарочную карту можно использовать для оплаты только на сайте",
    info3: "Подарочная карта не имеет срока действия",
    notAvailable: "Подарочная карта сейчас недоступна",
    addedToCart: "Подарочная карта добавлена в корзину",
  },
  ar: {
    title: "بطاقة هدايا", heroDesc: "بطاقة هدايا أليس تمنح أحبائكم خيار اختيار المجوهرات المثالية",
    chooseAmount: "اختر المبلغ", afterPurchase: "بعد الشراء، سيتم إرسال رمز بطاقة الهدايا إلى بريدكم الإلكتروني",
    selectedAmount: "المبلغ المختار", addToCart: "أضف إلى السلة",
    info1: "سيتم إرسال بطاقة الهدايا إلى بريدكم فور الشراء",
    info2: "يمكن استخدام بطاقة الهدايا للدفع على الموقع فقط",
    info3: "بطاقة الهدايا ليس لها تاريخ انتهاء",
    notAvailable: "بطاقة الهدايا غير متوفرة حاليًا",
    addedToCart: "تمت إضافة بطاقة الهدايا إلى السلة",
  },
};

// ─── TrackOrder Page ─────────────────────────────────────────
export const trackOrder = {
  en: {
    title: "Repair Tracking", subtitle: "Track your order status in real time",
    enterPhone: "Enter your phone number", sendCode: "We'll send you a verification code",
    phoneLabel: "Phone number", sendingCode: "Sending code...", sendOtp: "Send me a verification code",
    haveAccount: "Have an account?", loginHere: "Login here",
    howItWorks: "How does it work?",
    step1Title: "Enter phone number", step1Desc: "The phone number appears on the receipt you received when submitting the repair",
    step2Title: "Verify identity", step2Desc: "Enter the verification code sent to you",
    step3Title: "View orders", step3Desc: "Track the status in real time",
    enterOtp: "Enter verification code", otpSentTo: "Verification code sent to number",
    verifying: "Verifying...", resendCode: "Resend code", resendIn: "Resend code",
    changePhone: "Change phone number",
    openAccount: "Open an account and get benefits!", joinUs: "Join us and get updates, exclusive discounts and easier tracking",
    toPersonalArea: "To personal area",
    yourOrders: "Your orders", ordersFound: "orders found", checkAnother: "Check another order",
    noOrdersFound: "No orders found", noOrdersDesc: "No orders found for this number. If you recently placed an order, it may not have been entered into the system yet.",
    pending: "Pending", inRepair: "In repair", waitingInStore: "Waiting in store", delivered: "Delivered",
    requestNumber: "Request number", created: "Created", updated: "Updated",
    storePickup: "Store pickup", pickupDesc: "You can pick up your order from our store during business hours",
    addressLabel: "Address", phoneContact: "Phone", businessHours: "Business Hours",
    emailLabel: "Email", navigateWaze: "Navigate with Waze",
  },
  ru: {
    title: "Отслеживание ремонта", subtitle: "Отслеживайте статус заказа в реальном времени",
    enterPhone: "Введите номер телефона", sendCode: "Мы отправим вам код подтверждения",
    phoneLabel: "Номер телефона", sendingCode: "Отправка кода...", sendOtp: "Отправить код подтверждения",
    haveAccount: "Есть аккаунт?", loginHere: "Войти здесь",
    howItWorks: "Как это работает?",
    step1Title: "Введите номер телефона", step1Desc: "Номер телефона указан на квитанции",
    step2Title: "Подтвердите личность", step2Desc: "Введите отправленный код",
    step3Title: "Просмотрите заказы", step3Desc: "Отслеживайте статус в реальном времени",
    enterOtp: "Введите код подтверждения", otpSentTo: "Код отправлен на номер",
    verifying: "Проверяем...", resendCode: "Отправить новый код", resendIn: "Отправить код",
    changePhone: "Изменить номер",
    openAccount: "Откройте аккаунт и получите преимущества!", joinUs: "Присоединяйтесь и получайте обновления и скидки",
    toPersonalArea: "В личный кабинет",
    yourOrders: "Ваши заказы", ordersFound: "заказов найдено", checkAnother: "Проверить другой заказ",
    noOrdersFound: "Заказы не найдены", noOrdersDesc: "Заказов по этому номеру не найдено.",
    pending: "Ожидание", inRepair: "В ремонте", waitingInStore: "Ожидает в магазине", delivered: "Доставлен",
    requestNumber: "Номер заявки", created: "Создан", updated: "Обновлён",
    storePickup: "Самовывоз из магазина", pickupDesc: "Вы можете забрать заказ в часы работы",
    addressLabel: "Адрес", phoneContact: "Телефон", businessHours: "Часы работы",
    emailLabel: "Эл. почта", navigateWaze: "Навигация через Waze",
  },
  ar: {
    title: "تتبع الإصلاحات", subtitle: "تتبع حالة طلبك في الوقت الفعلي",
    enterPhone: "أدخل رقم هاتفك", sendCode: "سنرسل لك رمز تحقق",
    phoneLabel: "رقم الهاتف", sendingCode: "جاري إرسال الرمز...", sendOtp: "أرسل لي رمز تحقق",
    haveAccount: "لديك حساب؟", loginHere: "سجل دخولك هنا",
    howItWorks: "كيف يعمل؟",
    step1Title: "أدخل رقم الهاتف", step1Desc: "رقم الهاتف موجود على الإيصال",
    step2Title: "تحقق من الهوية", step2Desc: "أدخل رمز التحقق المرسل إليك",
    step3Title: "اعرض الطلبات", step3Desc: "تتبع الحالة في الوقت الفعلي",
    enterOtp: "أدخل رمز التحقق", otpSentTo: "تم إرسال رمز التحقق إلى الرقم",
    verifying: "جاري التحقق...", resendCode: "إعادة إرسال الرمز", resendIn: "إعادة إرسال",
    changePhone: "تغيير رقم الهاتف",
    openAccount: "افتح حسابًا واحصل على مزايا!", joinUs: "انضم إلينا واحصل على تحديثات وخصومات حصرية",
    toPersonalArea: "إلى المنطقة الشخصية",
    yourOrders: "طلباتك", ordersFound: "طلبات وُجدت", checkAnother: "تحقق من طلب آخر",
    noOrdersFound: "لم يتم العثور على طلبات", noOrdersDesc: "لم يتم العثور على طلبات لهذا الرقم.",
    pending: "قيد الانتظار", inRepair: "قيد الإصلاح", waitingInStore: "ينتظر في المتجر", delivered: "تم التسليم",
    requestNumber: "رقم الطلب", created: "تم الإنشاء", updated: "تم التحديث",
    storePickup: "الاستلام من المتجر", pickupDesc: "يمكنك استلام طلبك خلال ساعات العمل",
    addressLabel: "العنوان", phoneContact: "الهاتف", businessHours: "ساعات العمل",
    emailLabel: "البريد الإلكتروني", navigateWaze: "انتقل عبر Waze",
  },
};

// ─── RingSizeGuide Page ─────────────────────────────────────────
export const ringSizeGuide = {
  en: {
    title: "Ring Size Guide", subtitle: "We've prepared a size guide to help you order the ring in the right size",
    importantNote: "Important note:", importantNoteDesc: "Ring sizes vary from right hand to left hand and depend on weather conditions and finger effort before measurement. It is recommended to measure after rest and in reasonable weather conditions.",
    toolsTitle: "Required tools:", tool1: "Thread", tool2: "Ruler", tool3: "Finger",
    haveRing: "Already have a ring?", haveRingDesc: "If you already have a ring and want to find out its size, you can use the size finder app:",
    downloadAndroid: "Download the app for Android, click here!", downloadIphone: "Download the app for iPhone, click here!",
    letsStart: "OK, let's start:",
    step1: "Using a sewing thread, or any other thread, wrap it around the desired finger at its thickest part.",
    step2: "Mark the spot on the thread representing the finger circumference with a pen.",
    step3: "Place the thread on a ruler, check the thread length to the marked area and compare to the following table:",
    sizeTable: "Size Table", circumference: "Size by finger circumference (mm)", sizeNumber: "Size by number",
  },
  ru: {
    title: "Гид по размерам колец", subtitle: "Мы подготовили гид по размерам, который поможет заказать кольцо подходящего размера",
    importantNote: "Важно:", importantNoteDesc: "Размер колец варьируется от правой руки к левой и зависит от погодных условий. Рекомендуется измерять после отдыха.",
    toolsTitle: "Необходимые инструменты:", tool1: "Нитка", tool2: "Линейка", tool3: "Палец",
    haveRing: "Уже есть кольцо?", haveRingDesc: "Если у вас уже есть кольцо, используйте приложение для определения размера:",
    downloadAndroid: "Скачать для Android, нажмите здесь!", downloadIphone: "Скачать для iPhone, нажмите здесь!",
    letsStart: "Итак, начнём:",
    step1: "С помощью нитки оберните палец в самом широком месте.",
    step2: "Отметьте ручкой место на нитке, обозначающее окружность пальца.",
    step3: "Положите нитку на линейку, проверьте длину до отметки и сравните с таблицей:",
    sizeTable: "Таблица размеров", circumference: "Размер по окружности (мм)", sizeNumber: "Размер по номеру",
  },
  ar: {
    title: "دليل مقاسات الخواتم", subtitle: "أعددنا لكم دليل مقاسات لمساعدتكم في طلب الخاتم بالمقاس المناسب",
    importantNote: "ملاحظة مهمة:", importantNoteDesc: "تختلف مقاسات الخواتم من اليد اليمنى إلى اليسرى وتعتمد على الطقس. يُنصح بالقياس بعد الراحة.",
    toolsTitle: "الأدوات المطلوبة:", tool1: "خيط", tool2: "مسطرة", tool3: "إصبع",
    haveRing: "لديك خاتم بالفعل؟", haveRingDesc: "إذا كان لديك خاتم وتريد معرفة مقاسه، يمكنك استخدام تطبيق تحديد المقاس:",
    downloadAndroid: "لتحميل التطبيق للأندرويد، اضغط هنا!", downloadIphone: "لتحميل التطبيق للآيفون، اضغط هنا!",
    letsStart: "حسنًا، لنبدأ:",
    step1: "باستخدام خيط، لف الإصبع المطلوب في أعرض جزء منه.",
    step2: "ضع علامة بالقلم على الخيط عند نقطة محيط الإصبع.",
    step3: "ضع الخيط على المسطرة، تحقق من الطول حتى العلامة وقارن بالجدول التالي:",
    sizeTable: "جدول المقاسات", circumference: "المقاس حسب محيط الإصبع (مم)", sizeNumber: "المقاس حسب الرقم",
  },
};

// ─── Accessibility Page ─────────────────────────────────────────
export const accessibility = {
  en: {
    title: "Accessibility Statement", companyName: "Alice Jewelry Ltd.",
    updatedDate: "Accessibility statement updated on 10.10.2023",
    intro: "We at Alice Jewelry strive to ensure that our digital services are accessible to people with disabilities, and therefore have invested resources to facilitate the use of the site for people with disabilities, as much as possible, out of the belief that every person deserves the right to live in equality, dignity, comfort and independence.",
    importance: "We attach great importance to providing equal opportunity for people with disabilities to use the information displayed on the site:",
    accessibleSiteTitle: "What is an Accessible Website",
    accessibleSiteDesc: "An accessible website is a site that allows a person with a disability to browse with the same level of efficiency and enjoyment as other users, using the capabilities of the system on which it operates and through assistive technologies for accessibility.",
    adaptationsTitle: "Accessibility Adaptations on the Website",
    adaptationsDesc: "The accessibility adaptations on the site were made in accordance with Section C: Internet Services in the Equal Rights for Persons with Disabilities Regulations (Service Accessibility Adjustments) 2013, based on the Israeli Standard SI 5568 which is based on WCAG 2.0 guidelines, and the site has been made accessible to level AA.",
    supportTitle: "The site supports the use of assistive technologies such as:",
    support1: "Screen reader software", support2: "Keyboard navigation", support3: "Font enlargement to 4 sizes",
    support4: "Flash blocking", support5: "Contrast adjustment", support6: "Color blindness adaptation",
    support7: "Readable font change", support8: "Cursor enlargement", support9: "Display enlargement up to ~200%",
    support10: "Link and heading highlighting",
    orderAccessibility: "Accessibility for Website Orders",
    orderAccessibilityDesc: "If you need accessibility adjustments for making a purchase and/or for coordinating and receiving delivery, please note this in the order comments.",
    contactTitle: "Contact Us",
    contactIntro: "If you find an accessibility issue on the website or need help, please contact us:",
    contactPhone: "Phone: 079-5575576", contactEmail: "Email: store@alice.jewelry",
    closingMessage: "We wish you a pleasant browsing experience on our website!",
  },
  ru: {
    title: "Заявление о доступности", companyName: "Алис Ювелирные изделия ООО",
    updatedDate: "Заявление обновлено 10.10.2023",
    intro: "Мы в Алис Ювелирные изделия стремимся обеспечить доступность наших цифровых услуг для людей с ограниченными возможностями.",
    importance: "Мы придаём большое значение предоставлению равных возможностей для использования информации на сайте:",
    accessibleSiteTitle: "Что такое доступный сайт",
    accessibleSiteDesc: "Доступный сайт позволяет человеку с ограниченными возможностями пользоваться им с тем же уровнем эффективности, что и другие пользователи.",
    adaptationsTitle: "Адаптации доступности на сайте",
    adaptationsDesc: "Адаптации доступности были выполнены в соответствии с израильским стандартом SI 5568 на основе WCAG 2.0, до уровня AA.",
    supportTitle: "Сайт поддерживает вспомогательные технологии:",
    support1: "Программы чтения с экрана", support2: "Навигация с клавиатуры", support3: "Увеличение шрифта",
    support4: "Блокировка мерцания", support5: "Настройка контраста", support6: "Адаптация для дальтоников",
    support7: "Изменение на читаемый шрифт", support8: "Увеличение курсора", support9: "Увеличение отображения до ~200%",
    support10: "Выделение ссылок и заголовков",
    orderAccessibility: "Доступность для заказов",
    orderAccessibilityDesc: "Если вам нужны адаптации для совершения покупки или доставки, укажите это в комментариях к заказу.",
    contactTitle: "Свяжитесь с нами",
    contactIntro: "Если вы нашли проблему с доступностью или нуждаетесь в помощи:",
    contactPhone: "Телефон: 079-5575576", contactEmail: "Email: store@alice.jewelry",
    closingMessage: "Желаем вам приятного пользования нашим сайтом!",
  },
  ar: {
    title: "بيان إمكانية الوصول", companyName: "أليس للمجوهرات م.ض",
    updatedDate: "تم تحديث بيان إمكانية الوصول بتاريخ 10.10.2023",
    intro: "نحن في أليس للمجوهرات نسعى لضمان إمكانية الوصول إلى خدماتنا الرقمية للأشخاص ذوي الإعاقة.",
    importance: "نولي أهمية كبيرة لتوفير فرص متساوية لاستخدام المعلومات المعروضة على الموقع:",
    accessibleSiteTitle: "ما هو موقع إنترنت يسهل الوصول إليه",
    accessibleSiteDesc: "موقع يسهل الوصول إليه يتيح للأشخاص ذوي الإعاقة التصفح بنفس مستوى الكفاءة.",
    adaptationsTitle: "تعديلات إمكانية الوصول على الموقع",
    adaptationsDesc: "تم إجراء تعديلات إمكانية الوصول وفقًا للمعيار الإسرائيلي المبني على إرشادات WCAG 2.0 حتى المستوى AA.",
    supportTitle: "يدعم الموقع التقنيات المساعدة مثل:",
    support1: "برامج قراءة الشاشة", support2: "التصفح بلوحة المفاتيح", support3: "تكبير الخط",
    support4: "حظر الوميض", support5: "ضبط التباين", support6: "تكييف لعمى الألوان",
    support7: "تغيير الخط لأكثر قابلية للقراءة", support8: "تكبير المؤشر", support9: "تكبير العرض حتى ~200%",
    support10: "تمييز الروابط والعناوين",
    orderAccessibility: "إمكانية الوصول للطلبات",
    orderAccessibilityDesc: "إذا كنت بحاجة إلى ترتيبات وصول عند الشراء أو التسليم، يرجى ذكر ذلك في ملاحظات الطلب.",
    contactTitle: "اتصل بنا",
    contactIntro: "إذا وجدت مشكلة في إمكانية الوصول أو تحتاج إلى مساعدة:",
    contactPhone: "هاتف: 079-5575576", contactEmail: "بريد إلكتروني: store@alice.jewelry",
    closingMessage: "نتمنى لكم تجربة تصفح ممتعة على موقعنا!",
  },
};

// ─── CookiePolicy Page ─────────────────────────────────────────
export const cookiePolicy = {
  en: {
    title: "Cookie Policy", subtitle: "This page explains how we use cookies and similar technologies on our site, in accordance with GDPR regulations and the European ePrivacy Directive.",
    managePreferences: "Manage my cookie preferences",
    whatAreCookies: "What are Cookies?", whatAreCookiesDesc: "Cookies are small text files stored on your device (computer, phone or tablet) when you visit a website. They allow the site to \"remember\" your actions and preferences over time.",
    cookieTypes: "Types of Cookies We Use",
    necessaryTitle: "Necessary Cookies", necessaryDesc: "These cookies are essential for the basic functioning of the site. They enable actions like site navigation, access to secure areas, saving items in the shopping cart and logging into your account.",
    necessaryBadge: "Always active • Cannot be disabled",
    analyticsTitle: "Statistics and Analytics Cookies", analyticsDesc: "These cookies help us understand how visitors use the site by collecting anonymous statistical information.",
    analyticsProviders: "Providers:", 
    marketingTitle: "Marketing and Advertising Cookies", marketingDesc: "These cookies are used to display relevant advertisements and track the effectiveness of marketing campaigns.",
    functionalTitle: "Functional Cookies", functionalDesc: "These cookies enable advanced and personalized functions such as saving language preferences, viewing videos, social network integration and additional interactive features.",
    manageTitle: "How to Manage Your Cookies?", manageIntro: "You have full control over the cookies stored on your device:",
    manageViaWebsite: "Through our website:", manageViaWebsiteDesc: "Click the \"Manage Preferences\" button at the top of this page or the \"Cookie Management\" link at the bottom of any page.",
    manageViaBrowser: "Through your browser:", manageViaBrowserDesc: "Most browsers allow you to view, delete and block cookies from specific sites. Refer to your browser settings for more information.",
    thirdPartyTitle: "Third Party Providers", thirdPartyIntro: "We work with trusted third-party providers for analytics and marketing:",
    updatesTitle: "Policy Updates", updatesDesc: "We may update this policy from time to time. Any material changes will be published on this page with the last update date.",
    lastUpdate: "Last update: December 2025",
    contactTitle: "Contact Us", contactDesc: "If you have questions about our use of cookies, please contact us:",
  },
  ru: {
    title: "Политика использования файлов Cookie", subtitle: "Эта страница объясняет, как мы используем файлы cookie в соответствии с GDPR.",
    managePreferences: "Управление настройками cookie",
    whatAreCookies: "Что такое Cookie?", whatAreCookiesDesc: "Cookie — это небольшие текстовые файлы, сохраняемые на вашем устройстве при посещении сайта.",
    cookieTypes: "Типы cookie, которые мы используем",
    necessaryTitle: "Необходимые cookie", necessaryDesc: "Эти cookie необходимы для базовой работы сайта: навигация, безопасные зоны, корзина и авторизация.",
    necessaryBadge: "Всегда активны • Нельзя отключить",
    analyticsTitle: "Аналитические cookie", analyticsDesc: "Помогают понять, как посетители используют сайт, собирая анонимную статистику.",
    analyticsProviders: "Поставщики:",
    marketingTitle: "Маркетинговые cookie", marketingDesc: "Используются для отображения релевантной рекламы и отслеживания эффективности кампаний.",
    functionalTitle: "Функциональные cookie", functionalDesc: "Обеспечивают расширенные функции: сохранение языка, видео, интеграцию с соцсетями.",
    manageTitle: "Как управлять cookie?", manageIntro: "У вас полный контроль над cookie:",
    manageViaWebsite: "Через наш сайт:", manageViaWebsiteDesc: "Нажмите кнопку «Управление настройками» вверху этой страницы.",
    manageViaBrowser: "Через браузер:", manageViaBrowserDesc: "Большинство браузеров позволяют просматривать и блокировать cookie.",
    thirdPartyTitle: "Сторонние поставщики", thirdPartyIntro: "Мы работаем с надёжными сторонними поставщиками:",
    updatesTitle: "Обновления политики", updatesDesc: "Мы можем обновлять эту политику. Существенные изменения будут опубликованы на этой странице.",
    lastUpdate: "Последнее обновление: декабрь 2025",
    contactTitle: "Свяжитесь с нами", contactDesc: "Если у вас есть вопросы об использовании cookie:",
  },
  ar: {
    title: "سياسة ملفات تعريف الارتباط (Cookies)", subtitle: "توضح هذه الصفحة كيفية استخدامنا لملفات تعريف الارتباط وفقًا لـ GDPR.",
    managePreferences: "إدارة تفضيلات ملفات تعريف الارتباط",
    whatAreCookies: "ما هي ملفات تعريف الارتباط؟", whatAreCookiesDesc: "ملفات تعريف الارتباط هي ملفات نصية صغيرة تُخزن على جهازك عند زيارة موقع إنترنت.",
    cookieTypes: "أنواع ملفات تعريف الارتباط التي نستخدمها",
    necessaryTitle: "ملفات تعريف الارتباط الضرورية", necessaryDesc: "ضرورية لعمل الموقع الأساسي: التنقل والمناطق الآمنة والسلة وتسجيل الدخول.",
    necessaryBadge: "نشطة دائمًا • لا يمكن تعطيلها",
    analyticsTitle: "ملفات تعريف الارتباط التحليلية", analyticsDesc: "تساعدنا في فهم كيفية استخدام الزوار للموقع من خلال جمع إحصاءات مجهولة.",
    analyticsProviders: "المزودون:",
    marketingTitle: "ملفات تعريف الارتباط التسويقية", marketingDesc: "تُستخدم لعرض إعلانات ذات صلة وتتبع فعالية الحملات.",
    functionalTitle: "ملفات تعريف الارتباط الوظيفية", functionalDesc: "تمكّن وظائف متقدمة مثل حفظ اللغة والفيديو وتكامل وسائل التواصل.",
    manageTitle: "كيف تدير ملفات تعريف الارتباط؟", manageIntro: "لديك تحكم كامل:",
    manageViaWebsite: "عبر موقعنا:", manageViaWebsiteDesc: "اضغط على زر «إدارة التفضيلات» أعلى هذه الصفحة.",
    manageViaBrowser: "عبر المتصفح:", manageViaBrowserDesc: "معظم المتصفحات تتيح عرض وحذف وحظر ملفات تعريف الارتباط.",
    thirdPartyTitle: "مزودو الطرف الثالث", thirdPartyIntro: "نعمل مع مزودين موثوقين:",
    updatesTitle: "تحديثات السياسة", updatesDesc: "قد نحدث هذه السياسة. ستُنشر التغييرات الجوهرية على هذه الصفحة.",
    lastUpdate: "آخر تحديث: ديسمبر 2025",
    contactTitle: "اتصل بنا", contactDesc: "إذا كانت لديك أسئلة حول استخدامنا لملفات تعريف الارتباط:",
  },
};
